import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Switch,
  TextField,
  makeStyles,
  Typography,
} from "@material-ui/core";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  timeInput: {
    marginTop: theme.spacing(2),
  },
}));

const BirthdaySettingsModal = ({ open, onClose }) => {
  const classes = useStyles();
  const [sendBirthdayMessage, setSendBirthdayMessage] = useState(false);
  const [birthdayMessageTime, setBirthdayMessageTime] = useState("09:00");

  useEffect(() => {
    if (open) {
      const fetchSettings = async () => {
        try {
          const { data } = await api.get("/settings");
          const enabledSetting = data.find((s) => s.key === "sendBirthdayMessage");
          const timeSetting = data.find((s) => s.key === "birthdayMessageTime");

          if (enabledSetting) {
            setSendBirthdayMessage(enabledSetting.value === "enabled");
          }
          if (timeSetting) {
            setBirthdayMessageTime(timeSetting.value);
          }
        } catch (err) {
          toastError(err);
        }
      };
      fetchSettings();
    }
  }, [open]);

  const handleSave = async () => {
    try {
      await api.put(`/settings/sendBirthdayMessage`, {
        value: sendBirthdayMessage ? "enabled" : "disabled",
      });
      await api.put(`/settings/birthdayMessageTime`, {
        value: birthdayMessageTime,
      });

      toast.success("Configurações de aniversário salvas com sucesso!");
      onClose();
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Configurações de Aniversário</DialogTitle>
      <DialogContent dividers className={classes.content}>
        <Typography variant="body2" color="textSecondary">
          Ative o disparo automático para que o sistema agende as mensagens de
          felicitação no dia do aniversário do contato.
        </Typography>
        
        <FormControlLabel
          control={
            <Switch
              checked={sendBirthdayMessage}
              onChange={(e) => setSendBirthdayMessage(e.target.checked)}
              color="primary"
            />
          }
          label="Habilitar envio automático de parabéns"
        />

        {sendBirthdayMessage && (
          <TextField
            label="Horário de envio"
            type="time"
            value={birthdayMessageTime}
            onChange={(e) => setBirthdayMessageTime(e.target.value)}
            className={classes.timeInput}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              step: 300, // 5 min
            }}
            variant="outlined"
            fullWidth
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">
          {i18n.t("whatsappModal.buttons.cancel")}
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BirthdaySettingsModal;
